import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Link } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface AdminModuleCardProps {
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
  featured?: boolean;
  deprecated?: boolean;
  category?: string;
}

export function AdminModuleCard({ 
  title, 
  description, 
  href, 
  icon: Icon, 
  featured, 
  deprecated,
  category 
}: AdminModuleCardProps) {
  return (
    <Link to={href} className="group">
      <Card className={`
        relative overflow-hidden transition-all duration-300 cursor-pointer
        hover:shadow-xl hover:shadow-primary/10 hover:-translate-y-1
        ${featured ? 'ring-2 ring-primary/20 border-primary/30 bg-gradient-to-br from-primary/5 to-background' : 'hover:border-primary/30'}
        ${deprecated ? 'opacity-60 border-dashed grayscale' : ''}
      `}>
        {featured && (
          <div className="absolute top-0 right-0 bg-gradient-to-l from-primary to-primary/80 text-primary-foreground px-3 py-1 text-xs font-medium rounded-bl-lg">
            New
          </div>
        )}
        
        <CardHeader className="pb-4">
          <div className="flex items-start gap-4">
            <div className={`
              p-3 rounded-xl transition-colors duration-300
              ${featured ? 'bg-primary/10 text-primary' : 'bg-muted group-hover:bg-primary/10 group-hover:text-primary'}
            `}>
              <Icon className="h-6 w-6" />
            </div>
            
            <div className="flex-1 min-w-0">
              <CardTitle className="text-lg font-semibold group-hover:text-primary transition-colors">
                {title}
              </CardTitle>
              {category && (
                <Badge variant="secondary" className="mt-1 text-xs">
                  {category}
                </Badge>
              )}
            </div>
          </div>
        </CardHeader>
        
        <CardContent className="pt-0">
          <CardDescription className="text-sm leading-relaxed">
            {description}
          </CardDescription>
          
          {deprecated && (
            <Badge variant="outline" className="mt-3 border-dashed">
              Legacy • Use newer tools instead
            </Badge>
          )}
        </CardContent>
      </Card>
    </Link>
  );
}